import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getDiagnosisOverview,
  type DiagnosisOverviewResult,
} from '@services/api/dashboard/diagnosis.api'

export function useDiagnosisOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<DiagnosisOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getDiagnosisOverview, {
    enabled,
    queued,
  })
}
